import { IconBase, IconBaseProps } from 'react-icons';

import { IconManifest } from 'app/agriculture/icons/types';

export const defaultViewIcon: IconManifest = {
    id: 'default-view-icon',
    width: 128,
    height: 128,
    d: 'M 21.33,16 A 5.33,5.33 0 0 0 16,21.33 V 42.67 A 5.33,5.33 0 0 0 21.33,48 5.33,5.33 0 0 0 26.67,42.67 V 34.21 L 49.56,57.11 a 5.33,5.33 0 0 0 7.54,0 5.33,5.33 0 0 0 0,-7.54 L 34.21,26.67 h 8.46 A 5.33,5.33 0 0 0 48,21.33 5.33,5.33 0 0 0 42.67,16 Z m 64,0 A 5.33,5.33 0 0 0 80,21.33 a 5.33,5.33 0 0 0 5.33,5.33 h 8.46 L 70.89,49.56 a 5.33,5.33 0 0 0 0,7.54 5.33,5.33 0 0 0 7.54,0 l 22.9,-22.9 v 8.46 A 5.33,5.33 0 0 0 106.67,48 5.33,5.33 0 0 0 112,42.67 V 21.33 A 5.33,5.33 0 0 0 111.59,19.29 5.33,5.33 0 0 0 110.44,17.56 5.33,5.33 0 0 0 106.67,16 Z m -32,53.33 A 5.33,5.33 0 0 0 49.56,70.89 L 26.67,93.79 V 85.33 A 5.33,5.33 0 0 0 21.33,80 5.33,5.33 0 0 0 16,85.33 V 106.67 A 5.33,5.33 0 0 0 21.33,112 H 42.67 A 5.33,5.33 0 0 0 48,106.67 5.33,5.33 0 0 0 42.67,101.33 H 34.21 L 57.11,78.44 a 5.33,5.33 0 0 0 0,-7.54 5.33,5.33 0 0 0 -3.77,-1.56 z m 21.33,0 a 5.33,5.33 0 0 0 -3.77,1.56 5.33,5.33 0 0 0 0,7.54 l 22.9,22.9 H 85.33 A 5.33,5.33 0 0 0 80,106.67 5.33,5.33 0 0 0 85.33,112 H 106.67 A 5.33,5.33 0 0 0 110.44,110.44 5.33,5.33 0 0 0 112,106.67 V 85.33 A 5.33,5.33 0 0 0 106.67,80 a 5.33,5.33 0 0 0 -5.33,5.33 v 8.46 L 78.44,70.89 a 5.33,5.33 0 0 0 -3.77,-1.56 z',
};

export function DefaultViewIcon(props: IconBaseProps) {
    const { id, d } = defaultViewIcon;

    return (
        <IconBase id={id} {...props} viewBox="16 16 96 96" data-testid="DefaultViewIcon">
            <path d={d} fill="currentColor" />
        </IconBase>
    );
}
